enum IndexEnum {
  'welcome_msg' = 'welcome_msg',
  'welcome_desc' = 'welcome_desc',
  'main_title.buy_or_sell' = 'main_title.buy_or_sell',
  'main_title.whiskey_and_spirits' = 'main_title.whiskey_and_spirits',
  'main_subtitle' = 'main_subtitle',
  'main_table.last_activities' = 'main_table.last_activities',
  'main_table.top_sellers' = 'main_table.top_sellers',
  'invest_main_banner' = 'invest_main_banner',
  'always_on_hand_main_banner' = 'always_on_hand_main_banner',
  'app.get_in_on' = 'app.get_in_on',
  'app.download_on_the' = 'app.download_on_the',
  'invest_collect_enjoy.title' = 'invest_collect_enjoy.title',
  'invest_collect_enjoy.description' = 'invest_collect_enjoy.description',
  'invest_collect_enjoy.button' = 'invest_collect_enjoy.button',
  'track_your_investments_in_whisky' = 'track_your_investments_in_whisky',
  'view_your_portfolio' = 'view_your_portfolio',
  'recommended_by_spiritory' = 'recommended_by_spiritory',
  'bottle_of_the_day' = 'bottle_of_the_day',
  'go_to_the_bottle' = 'go_to_the_bottle',
  'be_the_first_to_make_an_offer' = 'be_the_first_to_make_an_offer',
  'the_fastest_and_easiest' = 'the_fastest_and_easiest',
  'way_to_sell' = 'way_to_sell',
  'the_fastest_subtitle' = 'the_fastest_subtitle',
  'why_spiritory' = 'why_spiritory',
  'why_spiritory_subtitle' = 'why_spiritory_subtitle',
  'reason_one' = 'reason_one',
  'reason_one_subtitle' = 'reason_one_subtitle',
  'reason_two' = 'reason_two',
  'reason_two_subtitle' = 'reason_two_subtitle',
  'reason_three' = 'reason_three',
  'reason_three_subtitle' = 'reason_three_subtitle',
  'missing_bottle' = 'missing_bottle',
  'missing_bottle_subtitle' = 'missing_bottle_subtitle',
  'suggest_a_bottle' = 'suggest_a_bottle',
  'download_the_app' = 'download_the_app',
  'download_the_app_subtitle_1' = 'download_the_app_subtitle_1',
  'download_the_app_subtitle_2' = 'download_the_app_subtitle_2',
  'scan_me' = 'scan_me',
  'download_from' = 'download_from',
  'footer.first_receive_news' = 'footer.first_receive_news',
  'footer.first_receive_news_subtitle' = 'footer.first_receive_news_subtitle',
  'footer.about' = 'footer.about',
  'footer.international_whiskey' = 'footer.international_whiskey',
  'footer.imprint' = 'footer.imprint',
  'footer.terms' = 'footer.terms',
  'footer.data_privacy' = 'footer.data_privacy',
  'footer.investors' = 'footer.investors',
  'footer.press' = 'footer.press',
  'footer.all_rights_reserved' = 'footer.all_rights_reserved',
  'footer.submit' = 'footer.submit',
  'footer.enter_your_email' = 'footer.enter_your_email',
  'header.browse' = 'header.browse',
  'header.about' = 'header.about',
  'header.sell' = 'header.sell',
  'header.search_something_here' = 'header.search_something_here',
  'header.sign_up' = 'header.sign_up',
  'header.sign_in' = 'header.sign_in',
  'header.unread_messages' = 'header.unread_messages',
  'header.requires_action' = 'header.requires_action',
  'navBar.dashboard' = 'navBar.dashboard',
  'navBar.buying' = 'navBar.buying',
  'navBar.selling' = 'navBar.selling',
  'navBar.portfolio' = 'navBar.portfolio',
  'navBar.wish_list' = 'navBar.wish_list',
  'navBar.last_viewed' = 'navBar.last_viewed',
  'navBar.suggest_a_bottle' = 'navBar.suggest_a_bottle',
  'navBar.notifications' = 'navBar.notifications',
  'navBar.settings' = 'navBar.settings',
  'navBar.language' = 'navBar.language',
  'navBar.logout' = 'navBar.logout',
  'navBar.referrals' = 'navBar.referrals',
  'bottles_of_the_month.bottles_of_the_month' = 'bottles_of_the_month.bottles_of_the_month',
  'bottles_of_the_month.bottles_of_the_month_subtitle' = 'bottles_of_the_month.bottles_of_the_month_subtitle',
  'bottles_of_the_month.explore_our_collection' = 'bottles_of_the_month.explore_our_collection',
  'bottles_of_the_month_april_2025.bottles_of_the_month' = 'bottles_of_the_month_april_2025.bottles_of_the_month',
  'bottles_of_the_month_april_2025.bottles_of_the_month_subtitle' = 'bottles_of_the_month_april_2025.bottles_of_the_month_subtitle',
  'bottles_of_the_month_april_2025.explore_our_collection' = 'bottles_of_the_month_april_2025.explore_our_collection',
  'glenfiddich.glenfiddich_selection' = 'glenfiddich.glenfiddich_selection',
  'glenfiddich.glenfiddich_selection_subtitle' = 'glenfiddich.glenfiddich_selection_subtitle',
  'glenfiddich.discover_more' = 'glenfiddich.discover_more',
  'love_letter.love_letter_in_a_bottle' = 'love_letter.love_letter_in_a_bottle',
  'love_letter.love_letter_in_a_bottle_subtitle' = 'love_letter.love_letter_in_a_bottle_subtitle',
  'love_letter.discover_our_collection' = 'love_letter.discover_our_collection',
  'macallan.h2' = 'macallan.h2',
  'macallan.p' = 'macallan.p',
  'macallan.h2_2' = 'macallan.h2_2',
  'discover_more' = 'discover_more',
  'discover_products' = 'discover_products',
  'read_our_blog' = 'read_our_blog',
  'read_the_interview' = 'read_the_interview',
  'interview_header' = 'interview_header',
  'interview_content' = 'interview_content',
  'why_spiritory_mobile.buy_and_sell_spirits_at_your_own_price' = 'why_spiritory_mobile.buy_and_sell_spirits_at_your_own_price',
  'why_spiritory_mobile.buy_and_sell_spirits_at_your_own_price_sub' = 'why_spiritory_mobile.buy_and_sell_spirits_at_your_own_price_sub',
  'why_spiritory_mobile.be_the_first_to_known_the_best_prices' = 'why_spiritory_mobile.be_the_first_to_known_the_best_prices',
  'why_spiritory_mobile.be_the_first_to_known_the_best_prices_sub' = 'why_spiritory_mobile.be_the_first_to_known_the_best_prices_sub',
  'why_spiritory_mobile.buy_only_verified_alcohol' = 'why_spiritory_mobile.buy_only_verified_alcohol',
  'why_spiritory_mobile.buy_only_verified_alcohol_sub' = 'why_spiritory_mobile.buy_only_verified_alcohol_sub',
  'give_away_header' = 'give_away_header',
  'give_away_text1' = 'give_away_text1',
  'give_away_text2' = 'give_away_text2',
  'ardbeg.title' = 'ardbeg.title',
  'ardbeg.text' = 'ardbeg.text',
  'bowmore_selection_april_2025.title' = 'bowmore_selection_april_2025.title',
  'bowmore_selection_april_2025.text' = 'bowmore_selection_april_2025.text',
  'bowmore_selection_april_2025.button' = 'bowmore_selection_april_2025.button',
  'spiritoryMarketplaceContent.0.id' = 'spiritoryMarketplaceContent.0.id',
  'spiritoryMarketplaceContent.0.title' = 'spiritoryMarketplaceContent.0.title',
  'spiritoryMarketplaceContent.0.description' = 'spiritoryMarketplaceContent.0.description',
  'spiritoryMarketplaceContent.1.id' = 'spiritoryMarketplaceContent.1.id',
  'spiritoryMarketplaceContent.1.title' = 'spiritoryMarketplaceContent.1.title',
  'spiritoryMarketplaceContent.1.description' = 'spiritoryMarketplaceContent.1.description',
  'spiritoryMarketplaceContent.2.id' = 'spiritoryMarketplaceContent.2.id',
  'spiritoryMarketplaceContent.2.title' = 'spiritoryMarketplaceContent.2.title',
  'spiritoryMarketplaceContent.2.description' = 'spiritoryMarketplaceContent.2.description',
  'spiritoryMarketplaceContent.3.id' = 'spiritoryMarketplaceContent.3.id',
  'spiritoryMarketplaceContent.3.title' = 'spiritoryMarketplaceContent.3.title',
  'spiritoryMarketplaceContent.3.description' = 'spiritoryMarketplaceContent.3.description',
  'spiritoryMarketplaceContent.4.id' = 'spiritoryMarketplaceContent.4.id',
  'spiritoryMarketplaceContent.4.title' = 'spiritoryMarketplaceContent.4.title',
  'spiritoryMarketplaceContent.4.description' = 'spiritoryMarketplaceContent.4.description',
  'spiritoryMarketplaceContent.5.id' = 'spiritoryMarketplaceContent.5.id',
  'spiritoryMarketplaceContent.5.title' = 'spiritoryMarketplaceContent.5.title',
  'spiritoryMarketplaceContent.5.description' = 'spiritoryMarketplaceContent.5.description',
  'reviewsh2' = 'reviewsh2',
  'reviewsloading' = 'reviewsloading',
}

export { IndexEnum };
